import { dumpTriggerMessage, dumpLogDataMessage } from '@/messages'
import { jsonRpc, mediator, messenger } from '@communication'
import { extractLog } from '@logger'

export default class LogProcedure {
  constructor() {
    this.name = 'LogProcedure'
    this.isPendingDump = false
    this.pendingReason = null
    this.pendingError = undefined
  }
  install = () => {
    jsonRpc.on('log:dumpTrigger', this.triggerDumpLog)
    messenger.subscribe(this.name, 'log:dumpStart', this.dumpLog)
  }
  dumpObject = obj => {
    if (obj instanceof Error) {
      return obj.stack
    } else {
      return JSON.stringify(obj, null, 2)
    }
  }
  triggerDumpLog = (event) => {
    const { reason, error } = event.detail
    if (this.isPendingDump) return
    this.isPendingDump = true
    this.pendingReason = reason
    this.pendingError = error instanceof Error ? error.stack : error
    jsonRpc.send(dumpTriggerMessage(reason, this.pendingError), null, 'no-log')
  }

  dumpLog = () => {
    const {
      service: { callId },
    } = mediator.session.configuration
    const { callId: liteSessionId } = mediator.session
    while (true) {
      const logToDump = extractLog()
        .map(item =>
          item
            .map(arg => {
              if (typeof arg === 'object') {
                return this.dumpObject(arg)
              } else {
                return arg
              }
            })
            .join(' ')
        )
        .join('\n')
      if (logToDump.length) {
        jsonRpc.send(
          dumpLogDataMessage(logToDump, this.pendingReason, this.pendingError, liteSessionId, callId),
          null,
          'no-log'
        )
      } else {
        break
      }
    }
    this.isPendingDump = false
    this.pendingReason = null
    this.pendingError = undefined
  }

  uninstall = () => {
    messenger.unsubscribe(this.name)
    jsonRpc.off('log:dumpTrigger', this.triggerDumpLog)
  }
}
